// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"yGpZeggx_vYtwd51AXN7","container":"T9J3JCx96liXJoBxKMBV","size":"Uji828_WScE7N7F9Ia3b","header":"shbojuXYklHSVpn24Fll"};